import moment from "moment";
import { createdById } from "../../constants";

export type EmrListType = {
  fullName: string,
  dob: string,
  gender: string,
  encounterID: number,
  emiratesId: string,
  passportNum: string,
  gccId: string,
  createdDate: string,
  patientId: number,
  lockTime: number,
  insurancePlan: string | null,
  insurance: string | null,
  age: string,
  ageDays: string,
  emrNo: string,
  insuranceType: string | null,
  lastName: string,
  ageMonths: string,
  middleName: string | null,
  patientStatus: string,
  firstName: string,
  insuranceName: string | null,
  paymentType: string,
  isCashed: number,
  modeOfPayment: string,
  doctorName: string,
  waitingTime: string | null;
  consultationStatus: string | null;
  consultationTime: string | null;
};



export type EmrListParams = {
  filter: { searchDate?: string; createdById: number; searchText?: string };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
  userType?: number;
};

export const initialSearchParams: EmrListParams = {
  filter: {
    createdById: createdById as number,searchDate:moment().format("YYYY-MM-DD")
  },
  sortOrder: "asc",
  sortField: "",
  pageNumber: 0,
  pageSize: 25,
};

export type EmrListResponseType = {
  count: number;
  psearchResponses: EmrListType[];
  
};
